import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function Redo(props) {
  const { height, width, iconColor } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <g id="Symbols" fill="none" fillRule="evenodd">
        <g id="Button/Map/RedoSearch" transform="translate(-116 -9)" fill={iconColor}>
          <g id="Icons/Map/ReSearch/White" transform="translate(114 7)">
            <path
              d="M12,22 C17.522,22 22,17.522 22,12 C22,6.477 17.522,2 12,2 C6.478,2 2,6.477 2,12 C2,14.251 2.744,16.329 3.999,18 L2,18 L2,19 L5,19 L6,19 L6,18 L6,15 L5,15 L5,17.644 C3.753,16.099 3,14.14 3,12 C3,7.029 7.029,3 12,3 C16.971,3 21,7.029 21,12 C21,16.971 16.971,21 12,21 L12,22 Z"
              id="Fill-1"
              transform="rotate(180 12 12)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

Redo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

Redo.defaultProps = {
  width: 20,
  height: 20,
  iconColor: colors.colorBlack
};

export default Redo;
